import styled from "styled-components";
import { deviceDF } from "../breakPoints";
export const InputStyled = styled.input`
  display: block;
  width: 100%;
  padding: 0px;
  line-height: 25px;
  font-size: 20px;
  font-weight: 400;
  -webkit-appearance: none;
  color: #08223e;
  border: 0px;
  background: transparent;
  outline: none;

  font-family: "Red Hat Display", Sans-serif;
  &::placeholder {
    color: #08223e;
    font-family: "Red Hat Display", Sans-serif;
  }
  margin-top: 0;
  margin-bottom: 0;
`;

export const SpanStyled = styled.span`
  display: flex;
  justify-content: center;
  width: 50px;
  height: 67px;
  padding: 0;
  right: 0;
  top: 0;
  position: absolute;
  font-size: 16px;
  border-radius: 0 20px 20px 0;
  border: 1px solid #999999;
  transform: translate(1px, -1px);
  color: #fff;
  background-color: #999999;
  &:active {
    background-color: #6b6b6b;
  }
  transition: background 0.3s ease, border 0.3s ease, color 0.3s ease;
  align-items: center;
  cursor: pointer;
  @media ${deviceDF.laptop} {
    height: 59px;
  }
  @media ${deviceDF.mobileL} {
    height: 51px;
  }
  @media ${deviceDF.mobileM} {
    height: 47px;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1.2rem;
  padding: 20px 30px;
  z-index: 1;
  position: relative;
  color: #99a3ba;
  border-width: 1px;
  border-color: ${props =>
    props.requiredField === 'error'
      ? "#e63946"
      : "#999999"};
  border-style: solid;
  background: #fff;
  border-radius: 20px;
  transition: border 0.3s ease;
  :focus-within {
    background-color: rgba(233, 245, 252, 1);
  }
  @media ${deviceDF.laptop} {
    padding: 16px 26px;
  }
  @media ${deviceDF.mobileL} {
    padding: 12px 22px;
  }
  @media ${deviceDF.mobileM} {
    padding: 10px 20px;
  }
`;

export const TextStyled = styled.p`
  width: 800px;
  @media ${deviceDF.laptop} {
    width: 600px;
  }
  @media ${deviceDF.mobileL} {
    text-align: center;
    width: 350px;
  }
  @media ${deviceDF.mobileM} {
    text-align: center;
    width: 340px;
  }
`;

export const LinkStyled = styled.a`
  color: #1f81c7;
  text-decoration: underline;
`;
